export default {
  meta: {
    title: '管理员设置'
  }
};
